// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-slide-group {
  display: flex;
  overflow: hidden;
}

:where(.vuetify-styles) .v-slide-group__next,
:where(.vuetify-styles) .v-slide-group__prev {
  align-items: center;
  display: flex;
  flex: 0 1 52px;
  justify-content: center;
  min-width: 52px;
  cursor: pointer;
}
:where(.vuetify-styles) .v-slide-group__next--disabled,
:where(.vuetify-styles) .v-slide-group__prev--disabled {
  pointer-events: none;
  opacity: var(--v-disabled-opacity);
}

:where(.vuetify-styles) .v-slide-group__content {
  display: flex;
  flex: 1 0 auto;
  position: relative;
  transition: 0.2s all cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
}
:where(.vuetify-styles) .v-slide-group__content > * {
  white-space: initial;
}

:where(.vuetify-styles) .v-slide-group__container {
  contain: content;
  display: flex;
  flex: 1 1 auto;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  scrollbar-color: rgba(0, 0, 0, 0);
}
:where(.vuetify-styles) .v-slide-group__container::-webkit-scrollbar {
  display: none;
}

:where(.vuetify-styles) .v-slide-group--vertical {
  max-height: inherit;
}
:where(.vuetify-styles) .v-slide-group--vertical,
:where(.vuetify-styles) .v-slide-group--vertical .v-slide-group__container,
:where(.vuetify-styles) .v-slide-group--vertical .v-slide-group__content {
  flex-direction: column;
}
:where(.vuetify-styles) .v-slide-group--vertical .v-slide-group__container {
  overflow-x: hidden;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VSlideGroup/VSlideGroup.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;AACA;;EAEE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,iDAAiD;EACjD,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".v-slide-group {\n  display: flex;\n  overflow: hidden;\n}\n\n.v-slide-group__next,\n.v-slide-group__prev {\n  align-items: center;\n  display: flex;\n  flex: 0 1 52px;\n  justify-content: center;\n  min-width: 52px;\n  cursor: pointer;\n}\n.v-slide-group__next--disabled,\n.v-slide-group__prev--disabled {\n  pointer-events: none;\n  opacity: var(--v-disabled-opacity);\n}\n\n.v-slide-group__content {\n  display: flex;\n  flex: 1 0 auto;\n  position: relative;\n  transition: 0.2s all cubic-bezier(0.4, 0, 0.2, 1);\n  white-space: nowrap;\n}\n.v-slide-group__content > * {\n  white-space: initial;\n}\n\n.v-slide-group__container {\n  contain: content;\n  display: flex;\n  flex: 1 1 auto;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: none;\n  scrollbar-color: rgba(0, 0, 0, 0);\n}\n.v-slide-group__container::-webkit-scrollbar {\n  display: none;\n}\n\n.v-slide-group--vertical {\n  max-height: inherit;\n}\n.v-slide-group--vertical,\n.v-slide-group--vertical .v-slide-group__container,\n.v-slide-group--vertical .v-slide-group__content {\n  flex-direction: column;\n}\n.v-slide-group--vertical .v-slide-group__container {\n  overflow-x: hidden;\n  overflow-y: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
